export const COUNTRIES_GET_REQUEST = "@countries.get.request";
export const COUNTRIES_GET_SUCCESS = "@countries.get.success";
export const COUNTRIES_GET_FAIL = "@countries.get.failure";
